/**
 * @generated SignedSource<<7926f881ae40f5495a935caf3b4fae18>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type BasisEnum = "CASH" | "NORMALIZED" | "%future added value";
export type cacPage_Query$variables = {
  basis?: BasisEnum | null | undefined;
  from?: string | null | undefined;
};
export type cacPage_Query$data = {
  readonly fullyLoadedCac: {
    readonly components: ReadonlyArray<{
      readonly categoryCount: number;
      readonly defaultIncluded: boolean;
      readonly key: string;
      readonly label: string;
      readonly monthly: ReadonlyArray<{
        readonly month: string;
        readonly spend: number;
      }>;
      readonly pnlLine: string | null | undefined;
    }>;
    readonly months: ReadonlyArray<string>;
    readonly newCustomers: ReadonlyArray<{
      readonly count: number;
      readonly month: string;
    }>;
  };
  readonly unitEconomics: {
    readonly arpu: number | null | undefined;
    readonly grossMarginTtm: number | null | undefined;
    readonly ltv: number | null | undefined;
  };
};
export type cacPage_Query = {
  response: cacPage_Query$data;
  variables: cacPage_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "basis"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "from"
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ltv",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "arpu",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "grossMarginTtm",
  "storageKey": null
},
v5 = [
  {
    "kind": "Variable",
    "name": "basis",
    "variableName": "basis"
  },
  {
    "kind": "Variable",
    "name": "from",
    "variableName": "from"
  }
],
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "months",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "month",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "count",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "key",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "label",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "pnlLine",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "defaultIncluded",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "categoryCount",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "spend",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "cacPage_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UnitEconomics",
        "kind": "LinkedField",
        "name": "unitEconomics",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v5/*: any*/),
        "concreteType": "FullyLoadedCac",
        "kind": "LinkedField",
        "name": "fullyLoadedCac",
        "plural": false,
        "selections": [
          (v6/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "CacMonthCount",
            "kind": "LinkedField",
            "name": "newCustomers",
            "plural": true,
            "selections": [
              (v7/*: any*/),
              (v8/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "CacComponent",
            "kind": "LinkedField",
            "name": "components",
            "plural": true,
            "selections": [
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "CacComponentPoint",
                "kind": "LinkedField",
                "name": "monthly",
                "plural": true,
                "selections": [
                  (v7/*: any*/),
                  (v14/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "cacPage_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UnitEconomics",
        "kind": "LinkedField",
        "name": "unitEconomics",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v15/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v5/*: any*/),
        "concreteType": "FullyLoadedCac",
        "kind": "LinkedField",
        "name": "fullyLoadedCac",
        "plural": false,
        "selections": [
          (v6/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "CacMonthCount",
            "kind": "LinkedField",
            "name": "newCustomers",
            "plural": true,
            "selections": [
              (v7/*: any*/),
              (v8/*: any*/),
              (v15/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "CacComponent",
            "kind": "LinkedField",
            "name": "components",
            "plural": true,
            "selections": [
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "CacComponentPoint",
                "kind": "LinkedField",
                "name": "monthly",
                "plural": true,
                "selections": [
                  (v7/*: any*/),
                  (v14/*: any*/),
                  (v15/*: any*/)
                ],
                "storageKey": null
              },
              (v15/*: any*/)
            ],
            "storageKey": null
          },
          (v15/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "47519d886f426a11dff375d3282dba07",
    "id": null,
    "metadata": {},
    "name": "cacPage_Query",
    "operationKind": "query",
    "text": "query cacPage_Query(\n  $from: String\n  $basis: BasisEnum\n) {\n  unitEconomics {\n    ltv\n    arpu\n    grossMarginTtm\n    id\n  }\n  fullyLoadedCac(from: $from, basis: $basis) {\n    months\n    newCustomers {\n      month\n      count\n      id\n    }\n    components {\n      key\n      label\n      pnlLine\n      defaultIncluded\n      categoryCount\n      monthly {\n        month\n        spend\n        id\n      }\n      id\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "dedef64adb1f6a55f63af7ee9adf1adf";

export default node;
